import { Typography } from 'fronton-react';
import React, { useState } from 'react';
import { ChevronDownIcon } from '@fronton/icons-react';
import {
	AccordionChevron,
	AccordionContentStyles,
	AccordionHeaderStyles,
	AccordionOpen,
	OpenChevron,
	QuestionsAccordionItemStyles,
} from './styles';
import { QuestionType } from '../questions-db';
import { GAClickButton } from 'utils';

export const AccordionItem = ({ text, answer }: QuestionType) => {
	const [open, setOpen] = useState(false);
	const toggleAccordion = () => {
		GAClickButton({
			elementBlock: 'landingChernovoyRemont',
			elementName: 'Вопросы и ответы',
			elementText: text,
		});
		setOpen(prev => !prev);
	};
	return (
		<div className={QuestionsAccordionItemStyles}>
			<div className={`${AccordionHeaderStyles} ${open ? 'open' : ''}`}>
				<Typography variant="m" size={open ? 'body_accent' : 'body_long'}>
					{text}
				</Typography>
				<ChevronDownIcon
					stopColor="#333333"
					className={`${AccordionChevron} ${open ? OpenChevron : ''}`}
					onClick={() => toggleAccordion()}
				/>
			</div>
			<div className={`${AccordionContentStyles} ${open ? AccordionOpen : ''}`}>{answer}</div>
		</div>
	);
};
